import React from 'react';
import Udesk from 'Udesk';
import SubRoutes from 'udesk-react/src/components/sub-routes';
import { Redirect } from 'react-router-dom';
import './style.scss';

const Template = React.memo((props: any) => {
    const { routes, location, route } = props;

    // 如果访问根路径，重定向到角色管理
    if (location.pathname === route.path) {
        const toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
            routeName: route.name,
        });
        return <Redirect to={toPath} />;
    }

    return (
        <React.Fragment>
            <div className="role-manage-entry" style={{ height: '100%' }}>
                {routes.map((routeItem, i) => (
                    <SubRoutes key={i} route={routeItem} />
                ))}
            </div>
        </React.Fragment>
    );
});

export default Template;
